import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabasePublishableKey = (
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  import.meta.env.VITE_SUPABASE_ANON_KEY
)?.trim()

export const isSupabaseConfigured = Boolean(supabaseUrl && supabasePublishableKey)

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(supabaseUrl!, supabasePublishableKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null

export async function checkSupabaseConnection(): Promise<{
  connected: boolean
  configured: boolean
  error?: string
}> {
  if (!supabaseUrl || !supabasePublishableKey) {
    return {
      connected: false,
      configured: false,
      error: 'Supabase environment variables are not configured.',
    }
  }

  try {
    const response = await fetch(`${supabaseUrl}/auth/v1/health`, {
      headers: { apikey: supabasePublishableKey },
    })
    if (!response.ok) {
      return {
        connected: false,
        configured: true,
        error: `Supabase health check returned HTTP ${response.status}.`,
      }
    }
    return { connected: true, configured: true }
  } catch (error) {
    return {
      connected: false,
      configured: true,
      error: error instanceof Error ? error.message : 'Unknown connection error.',
    }
  }
}
